<app-data-setup-common-content [isIos]="true" [isTmo]="false" [isGeneration]="true"></app-data-setup-common-content>
<div class="fourth-generation-container page-section">
    <div class="back-section">
        <a (click)="back()"><img src="assets/icon/primary-back-arrow.svg" width="20" height="20"
                alt="Back Arrow Icon">Back</a>
    </div>
    <div class="container-title">
        <img src="assets/icon/settings-icon.svg" width="24" height="24" alt="Settings Icon">
        <h5>iPhone 4G INSTRUCTIONS:</h5>
    </div>
    <p class="smaller">Please <b>download</b> the configuration file below on your FreeUpMobile device.*</p>
    <p class="smallest"><b>*Recommendation:</b> Open this link directly on the mobile device you want to set up your
        data on.</p>
    <div class="download-file-part">
        <p class="smaller"><b>iPhone 4G-RESELLER APN FILE:</b></p>
        <a href="assets/reseller.mobileconfig">Download File<img src="assets/icon/circle-down-arrow-icon.svg" width="20"
                height="20" alt="Arrow Icon"></a>
    </div>
    <div class="note-box">
        <div class="flex">
            <img src="assets/icon/banner-info-icon.svg" width="24" height="24" class="info-icon" alt="Info Icon">
            <div class="content">
                <p class="smaller">Some users may need to follow additional steps shown in this link. <b>Models: X, Xs,
                        Xr</b>.</p>
                <a (click)="showLTEsettingPopUp()">How to Download Link<img src="assets/icon/circle-down-arrow-icon.svg"
                        width="20" height="20" alt="Arrow Icon"></a>
            </div>
        </div>
    </div>
</div>